import React from 'react';
import { renderProcessedText } from '../../utils/textRenderer';

interface QRCodeComponentProps {
  content: Array<{
    header: string;
    imageLink: string;
  }>;
  isCarousel?: boolean;
}

const QRCodeComponent: React.FC<QRCodeComponentProps> = ({ content, isCarousel }) => {
  // Debug logging
  console.log('QRCodeComponent received content:', content);
  
  // Safety check for content
  if (!content || !Array.isArray(content) || content.length === 0) {
    console.log('QRCodeComponent: No content provided');
    return <div className="qr-code-component-error">No QR code data available</div>;
  }

  return (
    <div className="qr-code-component" style={{ height: isCarousel ? '100%' : 'auto' }}>
      {content.map((item, index) => (
        <div key={index} className="qr-code-component__item">
          {/* Header */}
          {item.header && (
            <div className="qr-code-component__header">
              {renderProcessedText(item.header)}
            </div>
          )}

          {/* QR Code Image */}
          {item.imageLink && (
            <div className="qr-code-component__image-container">
              <img 
                src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=app-download"
                alt={item.header || 'QR Code'} 
                className="qr-code-component__image"
                onError={(e) => {
                  console.error('Failed to load QR code image:', item.imageLink);
                  e.currentTarget.style.display = 'none';
                }}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default QRCodeComponent;
